import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

export type ColumnNameInputProps = {
  userInteraction: F<unknown, F0>;
  columnName?: string;
  isColumnNameError: boolean;
  disabled?: boolean;
};

export const ColumnNameInput: React.FC<ColumnNameInputProps> = ({
  columnName,
  userInteraction,
  isColumnNameError,
  disabled,
}) => {
  const inputElement = useRef<HTMLInputElement>();

  useEffect(() => {
    const timer = setTimeout(() => {
      inputElement.current?.focus();
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <NameInput
        ref={(input: HTMLInputElement) => (inputElement.current = input)}
        className="form-control"
        placeholder="Give metric a new name"
        value={columnName || ''}
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          userInteraction({
            columnName: e.target.value,
            columnNameChanged: true,
          })()
        }
      />
      {isColumnNameError && (
        <div className="alert alert-danger" role="alert">
          Column name <b>{columnName}</b> already in use
        </div>
      )}
    </div>
  );
};

const NameInput = styled.input`
  width: 170px;
  height: 36px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`;
